import { render, staticRenderFns } from "./DaySchedule.vue?vue&type=template&id=08b3925c&"
import script from "./DaySchedule.vue?vue&type=script&lang=js&"
export * from "./DaySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports